import React,{ useState, useEffect } from 'react';

import Fig1 from '../../images/hardware-setup/router-connectivity-figure-one.png';
import Fig2 from '../../images/hardware-setup/router-connectivity-figure-two.png';

function RouterConnectivity() {

    return (
        <div id="router-connectivity-component" className="modem-setup-component modem-connectivity-component">
            <h2>Expand Your Wifi Coverage</h2>
            <p style={{ fontSize:'0.9rem' }}>After setting up the M6a router, you can expand your wireless coverage by adding additional M6a devices as nodes to form a larger mesh network Note: Does not support adding nodes in batches. </p>
            <h4>Quick Tips</h4>
            <p style={{ fontSize:'0.9rem' }}>M6a performance is optimal when nodes are no more than two rooms apart from each other or the main M6a router.</p>
            <img style={{ maxWidth: '225px', marginBottom:'3rem' }} src={ Fig1 } />

            <div style={{ fontWeight:600, marginTop:'2rem' }}>1. Connect M6a to power</div>
            <p style={{ fontSize:'0.9rem' }}>Please wait for 1 minute after connecting the M6a to power. Once the indicator light becomes solid orange, proceed to the next step.</p>

            <div style={{ fontWeight:600, marginTop:'2rem' }}>2. Press the "Connect" button of the node</div>
            <p style={{ fontSize:'0.9rem' }}>The indicator light of node will begin flashing blue to signify that the device is in pairing mode and will change to white once the mesh connection is successful.</p>

            <div style={{ fontWeight:600, marginTop:'2rem' }}>3. Press the "Connect" button of the router or Click the "Next" button in the App</div>
            <p style={{ fontSize:'0.9rem' }}>The indicator light of router will begin flashing blue to signify that the device is in pairing mode and will change to white once the mesh connection is successful.</p>
            <img style={{ maxWidth: '420px', marginBottom:'3rem' }} src={ Fig2 } />

            <p style={{ fontSize:'0.9rem', marginTop: "1rem" }}>Visit <a href="http://mywifi.mercku.tech" target="_blank" >mywifi.mercku.tech</a> Or download the Mercku app to add and manage the network.  Questions about M6a installation? Please visit <a href="http://www.mercku.com/help" target="_blank" >www.mercku.com/help</a>.</p>
        </div>
    )
}

export default RouterConnectivity